/* Aplica solo PACK10 / PACK20 en el carrito a los suscriptores (az_sub) segun las unidades. */
(function(){
var busy=false,t=null;
function sub(){try{return localStorage.getItem('az_sub')==='1'}catch(e){return false}}
function want(n){return n>=3?'PACK20':(n>=2?'PACK10':'')}
function refresh(){
  var seen={};
  document.querySelectorAll('cart-discount-component').forEach(function(el){
    var sid=el.dataset.sectionId;
    if(!sid||seen[sid])return;
    seen[sid]=1;
    var mode=el.closest('theme-drawer')?'hydration':'full';
    import('@theme/section-renderer').then(function(m){return m.sectionRenderer.renderSection(sid,{cache:false,mode:mode})}).catch(function(){});
  });
}
function run(){
  if(busy||!sub())return;
  busy=true;
  fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}})
  .then(function(r){return r.json()})
  .then(function(c){
    var w=want(c.item_count);
    var codes=(c.discount_codes||[]).map(function(d){return d.code});
    var mine=codes.filter(function(x){return x==='PACK10'||x==='PACK20'});
    var ok=w?(mine.length===1&&mine[0]===w):mine.length===0;
    if(ok)return;
    var rest=codes.filter(function(x){return x!=='PACK10'&&x!=='PACK20'});
    if(w)rest.push(w);
    return fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({discount:rest.join(',')})}).then(function(){refresh()});
  })
  .catch(function(){})
  .then(function(){busy=false});
}
function later(){clearTimeout(t);t=setTimeout(run,500)}
var of=window.fetch;
window.fetch=function(i){
  var p=of.apply(this,arguments);
  try{
    var u=typeof i==='string'?i:(i&&i.url)||'';
    if(!busy&&(u.indexOf('/cart/add')>-1||u.indexOf('/cart/change')>-1||u.indexOf('/cart/update')>-1||u.indexOf('/cart/clear')>-1)){p.then(later,function(){})}
  }catch(e){}
  return p;
};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',later);else later();
window.addEventListener('pageshow',later);
})();
